'use strict';

module.exports = [
  '$scope',
  DummyController];

function DummyController ($scope) {

}



// WEBPACK FOOTER //
// ./src/js/app/DummyController.js